import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import config from '../../amplifyconfiguration.json';
import { Authenticator, ThemeProvider } from '@aws-amplify/ui-react';
import { amplifyTheme } from '@src/theme-amplify';
import { components } from '@components/amplify-components';
import { services } from '@components/amplify-services';
import { formFields } from '@components/amplify-form-fields';
import { Grid, rem } from '@mantine/core';
import { Header } from '@components/header';
import { LeftBanner } from '@components/left-banner';
import { Footer } from '@components/footer';
import classes from './branded-auth.module.css';

Amplify.configure(config);

interface BrandedAuthProps {
  children: React.ReactNode;
}

//TODO: Cancel button on sign-up form!
function BrandedAuth({ children }: BrandedAuthProps) {
  const location = useLocation();
  const [initialState, setInitialState] = useState<'signUp' | 'signIn' | 'forgotPassword' | undefined>(
    'signUp'
  );

  //TODO: Fix this, try to get signIn opr signUp from the link from the landing page
  useEffect(() => {
    setInitialState(() => location.state?.initialState || 'signUp');
    // console.log('#####', location.state.initialState);
    // console.log('#####', initialState);
  }, [location.state?.initialState]);
  0;
  console.log('initialState', initialState || null);

  return (
    <Grid gutter={0}>
      <Grid.Col span={4} className={classes.leftBanner}>
        <LeftBanner />
      </Grid.Col>
      <Grid.Col span={8} className={classes.mainColumn}>
        <Header mb={rem(30)} mt={rem(30)} />
        <ThemeProvider theme={amplifyTheme}>
          <Authenticator
            key={initialState}
            passwordSettings={{ minLength: 6, requireSpecialCharacters: false }}
            initialState={initialState}
            // socialProviders={['amazon', 'apple', 'facebook', 'google']}
            formFields={formFields}
            components={components}
            services={services}
          >
            {() => <>{children}</>}
          </Authenticator>
        </ThemeProvider>
        <Footer />
      </Grid.Col>
    </Grid>
  );
}

export { BrandedAuth };
